var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelinkd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_943_1332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 0C12.4182 0 16 3.58178 16 8.00001C16 12.4182 12.4182 16 8.00001 16C3.58178 16 0 12.4182 0 8.00001C0 3.58178 3.58178 0 8.00001 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94677 3.47732V3L2.96351 3V3.47732L3.94677 3.47732ZM2.96351 7.77027V3.47732H2.47189V7.77027H2.96351ZM2.47189 8.24758V7.77027H1.98026V8.24758H2.47189ZM1.98026 8.72199V8.24758H1V8.72199H1.98026ZM2.47189 9.19931V8.72199H1.98026V9.19931H2.47189ZM2.96351 13.4893V9.19931H2.47189V13.4893H2.96351ZM3.94677 13.9667V13.4893H2.96351V13.9667H3.94677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12441 11.583V11.1086H7.63278V7.29295H8.12441V6.81563H7.63278V5.861H7.14115V6.33831H6.64952V6.81563H6.16089V7.29295H6.64952V11.1086H6.16089V11.583H8.12441ZM10.0879 7.29295V6.33831H8.12441V6.81563H9.10766V7.29295H10.0879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0335 3.47732V3L12.0532 3V3.47732H13.0335ZM13.5251 7.77027V3.47732H13.0335V7.77027H13.5251ZM14.0167 8.24758V7.77027H13.5251V8.24758H14.0167ZM15 8.72199V8.24758H14.0167V8.72199H15ZM14.0167 9.19931V8.72199H13.5251V9.19931H14.0167ZM13.5251 13.4893V9.19931H13.0335V13.4893H13.5251ZM13.0335 13.9667V13.4893H12.0532V13.9667H13.0335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_943_1332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelinkd);
export default __webpack_public_path__ + "static/media/relinkd.88d3ded1.svg";
export { ForwardRef as ReactComponent };